import React, { useState, useCallback } from 'react';
import EmailTemplatesContainer from './EmailTemplates/EmailTemplates.container';
import RejectedResetContainer from './RejectedReset/RejectedReset.container';
import RetrieveContractContainer from './RetrieveContract/RetrieveContract.container';
import RetrieveTaskHistoryContainer from './RetrieveTaskHistory/RetrieveTaskHistory.container';
import Menu from './Menu';

const initialState = { activeMenu: '' };

const UtiliesContainer = () => {
    document.title = "Contract Management - Utilities";    

	const [{ activeMenu }, setActive] = useState(initialState);

	const handleMenuChange = useCallback(menuToOpen => {
		setActive({ activeMenu: menuToOpen });
	}, []);

	switch (activeMenu) {
		case 'email_templates':
			return <EmailTemplatesContainer onClose={handleMenuChange} />;
		case 'reset_contract':
			return <RejectedResetContainer onClose={handleMenuChange} />;
		case 'retrieve_contract':
			return <RetrieveContractContainer onClose={handleMenuChange} />;
		case 'retrieve_taskhistory':
			return <RetrieveTaskHistoryContainer onClose={handleMenuChange} />;
		default:
			return <Menu onChange={handleMenuChange} />;
	}
};

export default UtiliesContainer;
